import { DrawerCloseButton } from '@chakra-ui/react';

export const UiDrawerCloseButton = DrawerCloseButton;
